import React from 'react';
import { Flex, View } from '@smarterservices/smarter-ui';
import { usePaneMaxHeight } from '../../hooks/usePaneMaxHeight';

/**
 * DualPane
 *
 * A side-by-side layout with two scrollable columns.
 *
 * Props:
 *   - leftPane (ReactNode): Content for the left column.
 *   - rightPane (ReactNode): Content for the right column.
 */

const DualPane = ({ leftPane, rightPane }) => {
  const maxHeight = usePaneMaxHeight({
    offset: 180,
    maxHeightPercentage: 75, // Reduced to 75% to ensure footer visibility
    minHeight: 300,
  });
  return (
    <Flex direction="row" width="100%" height="100%">
      <View
        as="div"
        display="block"
        overflowY="auto"
        padding="small"
        width="50%"
        maxHeight="100%"
        className="dual-pane-left-pane"
      >
        {leftPane}
      </View>
      <View
        as="div"
        height="100%"
        background="primary"
        borderRadius="medium"
        borderWidth="0 0 0 small"
        borderColor="primary"
        aria-hidden="true"
      />
      <View
        as="div"
        display="block"
        overflowY="auto"
        padding="small"
        width="50%"
        maxHeight="100%"
        className="dual-pane-right-pane"
      >
        {rightPane}
      </View>
    </Flex>
  );
};

export default DualPane;
